import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';


const Ramp = ({ pwUnits, forcePath, PUB_ID, WEBSITE_ID }) => {
    const [rampComponentLoaded, setRampComponentLoaded] = useState(false);
    const location = useLocation();

    // const getBoltCallbacks = () => {

    //     window.Bolt.on('precontent_ad_video', window.Bolt.BOLT_AD_REQUEST_START, () => {
    //     console.log('Precontent Ad Requested');
    //     });
    
    //     window.Bolt.on('precontent_ad_video', window.Bolt.BOLT_AD_STARTED, () => {
    //     console.log('Precontent Ad Started');
    //     });
    
    //     window.Bolt.on('precontent_ad_video', window.Bolt.BOLT_AD_COMPLETE, () => {
    //     console.log('Precontent Ad Completed');
    //     // emit ad complete event
    //     });
    
    //     window.Bolt.on('precontent_ad_video', window.Bolt.BOLT_AD_ERROR, () => {
    //     console.log('Precontent Ad Error');
    //     // emit ad complete event
    //     });

    // };


    // Function to add ad units
    const addUnits = () => {
        window.ramp.que.push(() => {
            window.ramp.addUnits(pwUnits)
                .catch(e => console.warn('Error adding units:', e))
                .finally(() => window.ramp.displayUnits());
        });
    };

    // Cleanup function to remove ad units
    const cleanUp = () => {
        if (!window.ramp?.settings?.slots) return;
        const slotsToRemove = Object.keys(window.ramp.settings.slots);
        window.ramp.destroyUnits(slotsToRemove).then(addUnits);
    };

    useEffect(() => {
        if (!PUB_ID || !WEBSITE_ID) {
            console.error('Missing Publisher Id and/or Website Id');
            return;
        }

        if (!rampComponentLoaded) {
            setRampComponentLoaded(true);
            window.ramp = window.ramp || {};
            window.ramp.que = window.ramp.que || [];
            window.ramp.passiveMode = true;
            window.ramp.forcePath = forcePath || window.ramp.forcePath;

            // Load the Ramp configuration script
            const configScript = document.createElement('script');
            configScript.src = `https://cdn.intergient.com/${PUB_ID}/${WEBSITE_ID}/ramp.js`;
            document.head.appendChild(configScript);
            configScript.onload = addUnits; /* causing duplicate ad on initial site loads */
        }

        // Cleanup function to remove units on component unmount
        return () => { cleanUp(); };

    }, [rampComponentLoaded]);

    // Effect to handle forcePath updates 
    useEffect (() => {
        const currentPath = forcePath || location.pathname;

        if (!rampComponentLoaded) return;

        window.ramp.que.push(() => {
            window.ramp.setPath(currentPath || '');
            window.PageOS.session.newPageView();
        });
    }, [forcePath, location.pathname, rampComponentLoaded]);


    // useEffect(() => {

    //     window.ramp.onPlayerReady = getBoltCallbacks;

    // }, []);
    


    return null;
};

export default Ramp;